 
// app/page.tsx
"use client"
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import HomeComponent from "./home/page";
import LoadingComponent from "@/utils/LoadingComponent";
export const dynamic = "force-dynamic";
import Cookies from 'js-cookie';
export default function Home() {
  const router = useRouter();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Check if user is logged in (example: JWT token in localStorage)
    const token = Cookies.get("token");
    if (!token) {
      localStorage.clear();
      Cookies.remove("token");
      Cookies.remove("user");
      Cookies.remove("products");
      setLoading(false);
      return;
    }
    setLoading(false);
  }, [router]);

  // Optional: Show a nice loading spinner while checking
  if (loading) {
    return (
      <LoadingComponent/>

    );
  }

  // This will rarely be shown due to instant redirect
  return <HomeComponent></HomeComponent>;
}